import React, { useEffect, useState } from 'react';
import { FileStack, Flame, Users, Activity, Loader2 } from 'lucide-react';
import { TrackerLayout } from './TrackerLayout';
import { WeeklyLines } from './TrackerCharts';
import { trackerGet, CARD, dateTime } from './trackerApi';

const Stat = ({ icon: Icon, label, value, sub, testid, delay }) => (
  <div className={`${CARD} p-6 animate-in fade-in slide-in-from-bottom-2 duration-500`} style={{ animationDelay: `${delay}ms`, animationFillMode: 'both' }} data-testid={testid}>
    <div className="w-10 h-10 rounded-xl bg-[#FF451A]/10 flex items-center justify-center mb-5"><Icon size={18} className="text-[#FF451A]" /></div>
    <div className="text-xs font-semibold uppercase tracking-[0.08em] text-[#71717A] mb-1.5">{label}</div>
    <div className="text-3xl font-bold tracking-tight" data-testid={`${testid}-value`}>{value ?? '—'}</div>
    {sub && <div className="text-xs text-[#71717A] mt-1">{sub}</div>}
  </div>
);

const Dashboard = ({ account }) => {
  const [d, setD] = useState(null);
  useEffect(() => { trackerGet('/overview').then(setD); }, []);
  if (!d) return <Loader2 className="animate-spin text-[#FF451A]" size={18} />;
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        <Stat icon={FileStack} label="Competitor Posts This Month" value={d.posts_this_month} sub={`Across ${account.competitors.length} competitors · last ${d.window_days} days`} testid="stat-posts" delay={0} />
        <Stat icon={Flame} label="Most Active Competitor" value={d.most_active?.name} sub={d.most_active ? `${d.most_active.post_count} posts` : 'No posts yet'} testid="stat-most-active" delay={80} />
        <Stat icon={Users} label="Top Creator Tier Used" value={d.top_tier} sub={d.top_tier ? `${d.tier_split[d.top_tier]} of ${d.posts_this_month} posts` : 'Creator follower data not available yet'} testid="stat-top-tier" delay={160} />
        <Stat icon={Activity} label="Avg Engagement Rate" value={d.avg_er != null ? `${d.avg_er}%` : null} sub="Reels: ÷ views · Statics: ÷ followers" testid="stat-avg-er" delay={240} />
      </div>
      <div className={`${CARD} p-6`} data-testid="dashboard-weekly-chart">
        <div className="flex items-end justify-between mb-4">
          <div>
            <h2 className="text-lg font-semibold">Posting frequency</h2>
            <p className="text-xs text-[#71717A]">Posts per competitor, last 4 weeks</p>
          </div>
          <span className="text-[11px] text-[#A1A1AA]">Last updated {dateTime(account.last_scraped_at)}</span>
        </div>
        <WeeklyLines data={d.weekly} competitors={account.competitors} height={320} />
      </div>
    </div>
  );
};

export default function TrackerDashboard() {
  return (
    <TrackerLayout title="Overview" subtitle="What your competitors are doing on Instagram this month.">
      {(account) => <Dashboard account={account} />}
    </TrackerLayout>
  );
}
